import { render, staticRenderFns } from "./style-porperty.vue?vue&type=template&id=3d4e8f18&"
import script from "./style-porperty.vue?vue&type=script&lang=js&"
export * from "./style-porperty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports